import applyConverters from "axios-case-converter";
import axios from "axios";
import EventBus from "./eventbus";

const http = applyConverters(
  axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
    timeout: 60000 // 请求超时时间,
  })
);

const err = error => {
  if (error.response) {
    if (error.response.status === 403) {
      EventBus.$emit("i18n-toast", {
        variant: "warning",
        message: "PERMISSION-DENIED"
      });
    } else if (error.response.status === 401) {
      EventBus.$emit("i18n-toast", {
        variant: "warning",
        message: "NO-LOGIN"
      });
    }
  }
  return Promise.reject(error);
};

// response interceptor
http.interceptors.response.use(res => {
  if (res.data.success === false) {
    EventBus.$emit("i18n-toast", {
      variant: "warning",
      message: res.data.message
    });
  }
  return res;
}, err);

export default http;
